import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    api
      .get("/public/settings")
      .then((res) => setSettings(res.data || {}))
      .catch(() => setSettings({}));
  }, []);

  return <SettingsContext.Provider value={{ settings }}>{children}</SettingsContext.Provider>;
}

export function usePublicSettings() {
  const ctx = useContext(SettingsContext);
  return ctx ? ctx.settings : {};
}
